import { Grid, Typography, Box, useTheme } from '@mui/material';
import { useForm } from 'react-hook-form';

import { updateKPCS_GW } from 'apis/survey';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';
import MuiDialog from 'components/MuiDialog';
import {
  TKPCS_GWDefaultValues,
  SurveyDialogProps,
} from 'routes/Main/Survey/type';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import KPCSCGWontents from './KPCSCGWontents';
import KPCSCGWontents2 from './KPCSCGWontents2';
import KPCSCGWontents3 from './KPCSCGWontents3';
import KPCSGWContents4 from './KPCSCGWontents4';
import KPCSGWContents5 from './KPCSGWContents5';

import { useState } from 'react';

const KPCS_GW = (props: SurveyDialogProps<TKPCS_GWDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    patientInfo,
    nurseName,
    onClose,
  } = props;
  const { palette } = useTheme();

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();

  const { handleSubmit, watch, register, getValues, setValue } = useForm({
    defaultValues,
  });

  // test
  const [sum1, setSum1] = useState(0);
  const [sum2, setSum2] = useState(0);

  const [sum3, setSum3] = useState(0);
  const [sum4, setSum4] = useState(0);

  const [sum5, setSum5] = useState(0);
  const [sum6, setSum6] = useState(0);

  const [sum7, setSum7] = useState(0);
  const [sum8, setSum8] = useState(0);
  const [trancfusion, setTransfusion] = useState(
    getValues('no24_1') ? Math.floor(getValues('no24_1') * 2) : 0
  );

  const [sum9, setSum9] = useState(0);
  const [sum10, setSum10] = useState(0);
  const [sum11, setSum11] = useState(0);

  const onSubmit = (data: TKPCS_GWDefaultValues) => {
    const { patient_id } = patientInfo;
    const {} = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      kpcs_gw_survey: { ...data },
    };

    updateKPCS_GW(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);
        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    register,
    getValues,
    setValue,
    onRequired,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          한국형 환자분류도구 - 일반병동 (KPCS-GW)
        </Typography>
        <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
        {/* 1-9번 */}
        <KPCSCGWontents
          {...formProps}
          sum1={sum1}
          setSum1={setSum1}
          sum2={sum2}
          setSum2={setSum2}
        />
        {/* 10-14번 */}
        <KPCSCGWontents2
          {...formProps}
          sum3={sum3}
          setSum3={setSum3}
          sum4={sum4}
          setSum4={setSum4}
        />
        {/* 15-18번 */}
        <KPCSCGWontents3
          {...formProps}
          sum5={sum5}
          setSum5={setSum5}
          sum6={sum6}
          setSum6={setSum6}
        />
        {/* 19-25 */}
        <KPCSGWContents4
          {...formProps}
          sum7={sum7}
          setSum7={setSum7}
          sum8={sum8}
          setSum8={setSum8}
          trancfusion={trancfusion}
          setTransfusion={setTransfusion}
        />
        <KPCSGWContents5
          {...formProps}
          sum9={sum9}
          setSum9={setSum9}
          sum10={sum10}
          setSum10={setSum10}
          sum11={sum11}
          setSum11={setSum11}
        />
        <Box
          display={'flex'}
          flexDirection={'column'}
          alignItems={'flex-end'}
          sx={{ marginTop: '20px', width: '98%' }}
        >
          <Typography
            gutterBottom
            minWidth={115}
            fontWeight={700}
            fontSize={20}
            variant="subtitle1"
          >
            합계 :{' '}
            {sum1 +
              sum2 +
              sum3 +
              sum4 +
              sum5 +
              sum6 +
              sum7 +
              trancfusion +
              sum8 +
              sum9 +
              sum10 +
              sum11}{' '}
            점
          </Typography>
          <Typography
            minWidth={80}
            variant="caption"
            sx={{ color: `${palette.primary.main}` }}
          >
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                I군(경한환자) :
              </Box>
              0-10점
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                II군(보통환자) :
              </Box>
              11-20점
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                III군(중한환자) :
              </Box>
              21-30점
            </Typography>
            <Typography variant="inherit">
              <Box component={'strong'} mr={0.5}>
                IV군(위독한환자) :
              </Box>
              31점 이상
            </Typography>
          </Typography>
        </Box>
      </Grid>
    </MuiDialog.SurveyForm>
  );
};

export default KPCS_GW;
